import * as t from 'io-ts';

export const systemsCodec = t.type({
  sistemaEmpresa: t.number,
  sistema: t.union([t.number, t.null]),
  empresa: t.number,
  nome: t.string,
});
export type SystemsType = t.TypeOf<typeof systemsCodec>;
